'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('../../../../common/common.module.js');

require('./for-person');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResultsListController = function () {
  function ResultsListController(feis, fFeisService, msgService) {
    _classCallCheck(this, ResultsListController);

    this.feis = feis;
    this._ = {
      fFeisService: fFeisService,
      msgService: msgService
    };

    this.loadCompetitors();
  }

  _createClass(ResultsListController, [{
    key: 'loadCompetitors',
    value: function loadCompetitors() {
      var _this = this;

      this.loading = true;
      this.competitors = null;

      // FIXME(joshdmiller): pagination is the correct solution here.
      return this._.fFeisService.myCompetitors(this.feis.id, { count: true }).then(function (limit) {
        return _this._.fFeisService.myCompetitors(_this.feis.id, { limit: limit });
      }).then(function (competitors) {
        return _this.competitors = competitors;
      }).catch(function () {
        return _this._.msgService.displayErrorMsg('Could not load competitors');
      }).finally(function () {
        return _this.loading = false;
      });
    }
  }]);

  return ResultsListController;
}();

angular.module('ifeis.routes.feiseanna.one.results', ['ngMaterial', 'ui.router', 'ifeis.feiseanna', 'ifeis.routes.feiseanna.one.resultsForPerson']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.results', {
    url: '/results',
    template: require('./tpl.html'),
    controller: ResultsListController,
    controllerAs: 'results',
    ncyBreadcrumb: {
      label: 'Results',
      parent: 'feiseanna.one.landing-page'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/results/index.js
// module id = 596
// module chunks = 0